import { render, staticRenderFns } from "./web-settings.vue?vue&type=template&id=50d492ec&"
import script from "./web-settings.vue?vue&type=script&lang=ts&"
export * from "./web-settings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports